<template>
  <Slider
    v-if="isMobile && numRooms > 2"
    selector=".room-tabs__slider"
    :slidesToShow="numRooms === 3 ? 2 : 3"
    :slidesToScroll="1"
    :selectedRoom="selectedRoom"
    :responsiveInfinite="false"
    :dots="false"
  >
    <div class="room-tabs rd-view__main-content rhg-m-width rhg-my-0 room-tabs__slider">
      <div
        v-for="room in numRooms"
        :key="room"
        :class="[
          'room-tabs__chip',
          { 'room-tabs__chip--active': room === selectedRoom },
          {
            'room-tabs__chip--disabled': room > lastRoomSelected
          }
        ]"
        @click="selectRoom(room)"
        :ref="getRoomTabRef(room)"
      >
        {{ getRoomLabel(room) }}
      </div>
    </div>
  </Slider>

  <div
    v-else
    class="room-tabs rd-view__main-content rhg-m-width rhg-my-0"
    :class="isMobile && numRooms > 2 ? 'room-tabs__spacing-mobile' : 'room-tabs__spacing'"
  >
    <div
      v-for="room in numRooms"
      :key="room"
      :class="[
        'room-tabs__chip',
        { 'room-tabs__chip--active': room === selectedRoom },
        {
          'room-tabs__chip--disabled': room > lastRoomSelected
        }
      ]"
      @click="selectRoom(room)"
      :ref="getRoomTabRef(room)"
    >
      {{ getRoomLabel(room) }}
    </div>
  </div>
</template>

<script>
import Slider from '../../components/Slider.vue'
import { isMobileDevice } from '@/infrastructure/Utils'

export default {
  name: 'RoomTabs',
  components: {
    Slider
  },
  props: {
    numRooms: {
      type: Number,
      required: true
    },
    changeTab: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 1
    },
    hasRateAndMealPlanSelected: {
      type: Boolean,
      default: false
    },
    lastRoomSelected: {
      type: Number
    },
    selectedRates: {
      type: Array
    }
  },
  data() {
    return {
      selectedRoom: this.value,
      isMobile: isMobileDevice(),
      activatedRooms: [1]
    }
  },
  updated() {
    this.calculateRoomTabsWidth()
  },
  watch: {
    selectedRoom(newVal) {
      this.$emit('input', newVal)
      if (newVal === 1) {
        this.resetRooms()
      } else if (!this.activatedRooms.includes(newVal)) {
        this.activatedRooms.push(newVal)
      }

      if (this.isMobile && this.numRooms > 2 && newVal !== 1) {
        this.$nextTick(() => {
          const $slider = global.$('.room-tabs__slider')
          if ($slider.length) {
            $slider.slick('slickGoTo', newVal - 1, true)
          }
        })
      }
    },
    value(newVal) {
      this.selectedRoom = newVal
    },
    changeTab(newVal) {
      if (newVal) {
        this.goToNextRoom()
      }
    }
  },
  methods: {
    calculateRoomTabsWidth() {
      this.$nextTick(() => {
        for (let room = 1; room <= this.numRooms; room++) {
          const roomTab = this.$refs[this.getRoomTabRef(room)]
          if (roomTab) {
            const textWidth = roomTab[0].scrollWidth
            roomTab[0].style.maxWidth = `${textWidth + 20}px`
          }
        }
      })
    },
    getRoomTabRef(room) {
      return `roomTab${room}`
    },
    selectRoom(room) {
      if (room === 1) {
        this.resetRooms()
      }
      this.selectedRoom = room
    },
    goToNextRoom() {
      if (this.selectedRoom < this.numRooms) {
        this.selectedRoom += 1
      }
      this.$emit('update:changeTab', false)
    },
    resetRooms() {
      this.activatedRooms = [1]
    },
    getRoomLabel(room) {
      if (this.numRooms === 1) {
        return this.translate('rdRoomSelection', undefined, room)
      }
      if (room !== 1 && room === this.selectedRates?.length + 1) {
        return this.translate('rdSelectRoom')
      }
      if (room === 1 && !this.hasRateAndMealPlanSelected) {
        return this.translate('rdSelectMasterRoom')
      }
      return this.translate('rdRoomSelection', undefined, room)
    }
  }
}
</script>

<style lang="scss" scoped>
.room-tabs {
  display: flex;
  padding-bottom: 0 !important;
  padding-top: 24px;

  &__spacing {
    gap: 16px;
    @media (max-width: 992px) {
      padding: 20px 0 !important;
      gap: 0;
    }
  }

  &__spacing-mobile {
    justify-content: space-between;
    padding: 20px 0 !important;
  }

  &__chip {
    padding: 8px 16px;
    background-color: white;
    cursor: pointer;
    border-radius: 16px;
    font-size: 16px;
    text-align: center;
    max-width: 86px;
    width: auto !important;
    transition:
      opacity 0.3s ease-out,
      max-width 0.3s ease-out;
    color: #242424;
    white-space: nowrap;

    &--active {
      background-color: #29343d;
      color: white;
      max-width: 160px;
      font-weight: bold;
    }

    &--disabled {
      opacity: 0.5;
      pointer-events: none;
    }
    @media (max-width: 992px) {
      width: auto !important;
      margin-right: 12px;
    }
  }
  @media (max-width: 992px) {
    margin: 0 0rem 1rem;
    max-width: none;
  }
}
</style>
